import { Suspense, useEffect, useRef, useState } from 'react';

/**
 * Defers code and network work for content that starts below the initial
 * viewport. The reserved space prevents layout shifts while the module loads.
 */
export default function DeferredSection({ Component, minHeight = 240, className = '' }) {
  const ref = useRef(null);
  const [shouldRender, setShouldRender] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element || !('IntersectionObserver' in window)) {
      setShouldRender(true);
      return undefined;
    }

    const observer = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      setShouldRender(true);
      observer.disconnect();
    }, { rootMargin: '0px 0px -160px' });

    observer.observe(element);
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={ref} className={className} style={{ minHeight }}>
      {shouldRender && (
        <Suspense fallback={<div aria-hidden="true" style={{ minHeight }} />}>
          <Component />
        </Suspense>
      )}
    </div>
  );
}
